














































































































































































































































































































































import { CvValue, ElementType } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CV_VALUE_FILE_NAME_RULE, CV_VALUE_ELEMENT_METADATA_FIELDS, CV_VALUE_ELEMENT_TYPE_CATEGORIES, CV_VALUE_SMA_TYPES, CV_VALUE_COUNTRY } from '@/utils/constants'
import ApiClient from '@/services/api-client'
import { CvValueUtils } from '@/utils/cv-value-utils'

@Component({
  components: {
    ElementTypeHierarchy: () => import('@/components/ElementTypeHierarchy.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class UpsertElementTypeModal extends Vue {
  @Prop({ required: false }) elementType: ElementType

  @Watch('elementType', { deep: true })
  onElementTypeChanged() {
    this.updateElementType()
  }

  private elementTypeSave: ElementType = {
    codeId: '',
    name: '',
    codeTemplate: '',
    allowAssets: false,
    allowSiblings: false,
    fileNameRuleTypeId: '',
    childrenElementTypeAllowed: '',
    metadataRequired: '',
    metadataAllowed: '',
    codeComposedParent: '',
    autoGenerateCode: true,
    smaType: '',
    category: '',
    country: '',
    description: '',
    nameTemplate: '',
    defineMilestone: false,
    icon: ''
  }

  private elementTypes: ElementType[] = []
  private fileNameTypes: CvValue[] = []
  private elementMetadataFields: CvValue[] = []
  private elementTypeCategories: CvValue[] = []
  private smaTypes: CvValue[] = []
  private countries: CvValue[] = []

  created() {
    this.loadElementTypes()
    this.loadFileNameTypes()
    this.loadElementMetadataFields()
    this.loadElementTypeCategories()
    this.loadSmaTypes()
    this.loadCountries()
  }

  private updateElementType() {
    if (this.elementType.codeId !== '') {
      Vue.set(this.elementTypeSave, 'codeId', this.elementType.codeId)
      Vue.set(this.elementTypeSave, 'name', this.elementType.name)
      Vue.set(this.elementTypeSave, 'codeTemplate', this.elementType.codeTemplate)
      Vue.set(this.elementTypeSave, 'allowAssets', this.elementType.allowAssets)
      Vue.set(this.elementTypeSave, 'allowSiblings', this.elementType.allowSiblings)
      Vue.set(this.elementTypeSave, 'fileNameRuleTypeId', this.elementType.fileNameRuleTypeId)
      Vue.set(this.elementTypeSave, 'childrenElementTypeAllowed', this.elementType.childrenElementTypeAllowed)
      Vue.set(this.elementTypeSave, 'metadataRequired', this.elementType.metadataRequired)
      Vue.set(this.elementTypeSave, 'metadataAllowed', this.elementType.metadataAllowed)
      Vue.set(this.elementTypeSave, 'codeComposedParent', this.elementType.codeComposedParent)
      Vue.set(this.elementTypeSave, 'autoGenerateCode', this.elementType.autoGenerateCode)
      Vue.set(this.elementTypeSave, 'smaType', this.elementType.smaType)
      Vue.set(this.elementTypeSave, 'category', this.elementType.category)
      Vue.set(this.elementTypeSave, 'country', this.elementType.country)
      Vue.set(this.elementTypeSave, 'description', this.elementType.description)
      Vue.set(this.elementTypeSave, 'nameTemplate', this.elementType.nameTemplate)
      Vue.set(this.elementTypeSave, 'defineMilestone', this.elementType.defineMilestone)
      Vue.set(this.elementTypeSave, 'icon', this.elementType.icon)
    } else {
      this.clearForm()
    }
  }

  private async loadFileNameTypes() {
    this.fileNameTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_FILE_NAME_RULE)
  }

  private async loadElementMetadataFields() {
    this.elementMetadataFields = await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_METADATA_FIELDS)
  }

  private async loadElementTypeCategories() {
    this.elementTypeCategories = await CvValueUtils.getCvValuesByType(CV_VALUE_ELEMENT_TYPE_CATEGORIES)
  }

  private async loadSmaTypes() {
    this.smaTypes = await CvValueUtils.getCvValuesByType(CV_VALUE_SMA_TYPES)
  }

  private async loadCountries() {
    this.countries = await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private async loadElementTypes() {
    const response = await ApiClient.getElementTypes()
    this.elementTypes = response
  }

  private formOk(): boolean {
    return !!this.elementTypeSave.name && !!this.elementTypeSave.codeId && !!this.elementTypeSave.codeTemplate
  }

  hideModal() {
    this.$bvModal.hide('upsertElementTypeModal')
  }

  get childrenElementTypeAllowedComputed(): string[] {
    if (this.elementTypeSave.childrenElementTypeAllowed && this.elementTypeSave.childrenElementTypeAllowed !== '') {
      return this.elementTypeSave.childrenElementTypeAllowed.split(',')
    }
    return []
  }

  set childrenElementTypeAllowedComputed(value: string[]) {
    Vue.set(this.elementTypeSave, 'childrenElementTypeAllowed', value.join())
  }

  get metadataRequiredComputed(): string[] {
    if (this.elementTypeSave.metadataRequired && this.elementTypeSave.metadataRequired !== '') {
      return this.elementTypeSave.metadataRequired.split(',')
    }
    return []
  }

  set metadataRequiredComputed(value: string[]) {
    Vue.set(this.elementTypeSave, 'metadataRequired', value.join())
  }

  get metadataAllowedComputed(): string[] {
    if (this.elementTypeSave.metadataAllowed && this.elementTypeSave.metadataAllowed !== '') {
      return this.elementTypeSave.metadataAllowed.split(',')
    }
    return []
  }

  set metadataAllowedComputed(value: string[]) {
    Vue.set(this.elementTypeSave, 'metadataAllowed', value.join())
  }

  get codeComposedParentComputed(): string[] {
    if (this.elementTypeSave.codeComposedParent && this.elementTypeSave.codeComposedParent !== '') {
      return this.elementTypeSave.codeComposedParent.split(',')
    }
    return []
  }

  set codeComposedParentComputed(value: string[]) {
    Vue.set(this.elementTypeSave, 'codeComposedParent', value.join())
  }

  private saveElementType(): void {
    if (this.formOk()) {
      if (this.elementType.codeId !== '') {
        ApiClient.updateElementType(this.elementTypeSave.codeId, this.elementTypeSave)
          .then((elementTypeSaved: ElementType) => {
            this.$emit('elementTypeSaved', elementTypeSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            alert(`Error: ${ex.message}`)
          })
      } else {
        ApiClient.createElementType(this.elementTypeSave)
          .then((elementTypeSaved: ElementType) => {
            this.$emit('elementTypeSaved', elementTypeSaved)
            this.hideModal()
            this.clearForm()
          })
          .catch((ex: Error) => {
            alert(`Error: ${ex.message}`)
          })
      }
    } else {
      alert('Form not valid!')
    }
  }

  private clearForm() {
    Vue.set(this.elementTypeSave, 'codeId', '')
    Vue.set(this.elementTypeSave, 'name', '')
    Vue.set(this.elementTypeSave, 'codeTemplate', '')
    Vue.set(this.elementTypeSave, 'allowAssets', false)
    Vue.set(this.elementTypeSave, 'allowSiblings', false)
    Vue.set(this.elementTypeSave, 'fileNameRuleTypeId', '')
    Vue.set(this.elementTypeSave, 'childrenElementTypeAllowed', '')
    Vue.set(this.elementTypeSave, 'metadataRequired', '')
    Vue.set(this.elementTypeSave, 'metadataAllowed', '')
    Vue.set(this.elementTypeSave, 'codeComposedParent', '')
    Vue.set(this.elementTypeSave, 'autoGenerateCode', true)
    Vue.set(this.elementTypeSave, 'smaType', '')
    Vue.set(this.elementTypeSave, 'category', '')
    Vue.set(this.elementTypeSave, 'country', '')
    Vue.set(this.elementTypeSave, 'description', '')
    Vue.set(this.elementTypeSave, 'nameTemplate', '')
    Vue.set(this.elementTypeSave, 'defineMilestone', false)
    Vue.set(this.elementTypeSave, 'icon', '')
  }
}
